import { ApartmentStatus, Asset, AssetType } from '../../types/config';

export const inventoryDataAvram = [
  {
    building: 'M2',
    number: 1,
    type: 'M2D',
    floor: 1,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 1,
  },
  {
    building: 'M2',
    number: 2,
    type: 'M2D1',
    floor: 1,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D1_select_floor1',
    nrId: 2,
  },
  {
    building: 'M2',
    number: 3,
    type: 'M2B',
    floor: 1,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B_select_floor1',
    nrId: 3,
  },
  {
    building: 'M2',
    number: 4,
    type: 'M2A',
    floor: 1,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_A_select_floor1',
    nrId: 4,
  },
  {
    building: 'M2',
    number: 0,
    type: 'M2B1',
    floor: 1,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B1_select_floor1',
    nrId: 5,
  },
  {
    building: 'M2',
    number: 6,
    type: 'M2D',
    floor: 2,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 6,
  },
  {
    building: 'M2',
    number: 7,
    type: 'M2D1',
    floor: 2,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D1_select_floor2',
    nrId: 7,
  },
  {
    building: 'M2',
    number: 8,
    type: 'M2B',
    floor: 2,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B_select_floor2',
    nrId: 8,
  },
  {
    building: 'M2',
    number: 9,
    type: 'M2A',
    floor: 2,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_A_select_floor2',
    nrId: 9,
  },
  {
    building: 'M2',
    number: 10,
    type: 'M2B1',
    floor: 2,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B1_select_floor2',
    nrId: 10,
  },
  {
    building: 'M2',
    number: 11,
    type: 'M2D',
    floor: 3,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 11,
  },
  {
    building: 'M2',
    number: 12,
    type: 'M2D1',
    floor: 3,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D1_select_floor3',
    nrId: 12,
  },
  {
    building: 'M2',
    number: 13,
    type: 'M2B',
    floor: 3,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B_select_floor3',
    nrId: 13,
  },
  {
    building: 'M2',
    number: 14,
    type: 'M2A',
    floor: 3,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_A_select_floor3',
    nrId: 14,
  },
  {
    building: 'M2',
    number: 15,
    type: 'M2B1',
    floor: 3,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B1_select_floor3',
    nrId: 15,
  },
  {
    building: 'M2',
    number: 16,
    type: 'M2D',
    floor: 4,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 16,
  },
  {
    building: 'M2',
    number: 17,
    type: 'M2D1',
    floor: 4,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D1_select_floor4',
    nrId: 17,
  },
  {
    building: 'M2',
    number: 18,
    type: 'M2B',
    floor: 4,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B_select_floor4',
    nrId: 18,
  },
  {
    building: 'M2',
    number: 20,
    type: 'M2B1',
    floor: 4,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B1_select_floor4',
    nrId: 19,
  },
  {
    building: 'M2',
    number: 21,
    type: 'M2D',
    floor: 5,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 20,
  },
  {
    building: 'M2',
    number: 22,
    type: 'M2D1',
    floor: 5,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D1_select_floor5',
    nrId: 21,
  },
  {
    building: 'M2',
    number: 23,
    type: 'M2B',
    floor: 5,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B_select_floor5',
    nrId: 22,
  },
  {
    building: 'M2',
    number: 25,
    type: 'M2B1',
    floor: 5,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B1_select_floor5',
    nrId: 23,
  },
  {
    building: 'M2',
    number: 26,
    type: 'M2D',
    floor: 6,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 24,
  },
  {
    building: 'M2',
    number: 27,
    type: 'M2D1',
    floor: 6,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D1_select_floor6',
    nrId: 25,
  },
  {
    building: 'M2',
    number: 31,
    type: 'M2D',
    floor: 7,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 26,
  },
  {
    building: 'M2',
    number: 32,
    type: 'M2D1',
    floor: 7,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D1_select_floor7',
    nrId: 27,
  },
  {
    building: 'M2',
    number: 36,
    type: 'M2D',
    floor: 8,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 28,
  },
  {
    building: 'M2',
    number: 37,
    type: 'M2D1',
    floor: 8,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D1_select_floor8',
    nrId: 29,
  },
  {
    building: 'M2',
    number: 41,
    type: 'M2D',
    floor: 9,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor9',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 30,
  },
  {
    building: 'M3',
    number: 1,
    type: 'M3D',
    floor: 1,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 31,
  },
  {
    building: 'M3',
    number: 2,
    type: 'M3D1',
    floor: 1,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D1_select_floor1',
    nrId: 32,
  },
  {
    building: 'M3',
    number: 3,
    type: 'M3B',
    floor: 1,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B_select_floor1',
    nrId: 33,
  },
  {
    building: 'M3',
    number: 4,
    type: 'M3A',
    floor: 1,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_A_select_floor1',
    nrId: 34,
  },
  {
    building: 'M3',
    number: 5,
    type: 'M3B1',
    floor: 1,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B1_select_floor1',
    nrId: 35,
  },
  {
    building: 'M3',
    number: 6,
    type: 'M3D',
    floor: 2,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor2',
    nrId: 36,
  },
  {
    building: 'M3',
    number: 7,
    type: 'M3D1',
    floor: 2,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D1_select_floor2',
    nrId: 37,
  },
  {
    building: 'M3',
    number: 8,
    type: 'M3B',
    floor: 2,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B_select_floor2',
    nrId: 38,
  },
  {
    building: 'M3',
    number: 9,
    type: 'M3A',
    floor: 2,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_A_select_floor2',
    nrId: 39,
  },
  {
    building: 'M3',
    number: 10,
    type: 'M3B1',
    floor: 2,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B1_select_floor2',
    nrId: 40,
  },
  {
    building: 'M3',
    number: 11,
    type: 'M3D',
    floor: 3,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor3',
    nrId: 41,
  },
  {
    building: 'M3',
    number: 12,
    type: 'M3D1',
    floor: 3,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D1_select_floor3',
    nrId: 42,
  },
  {
    building: 'M3',
    number: 13,
    type: 'M3B',
    floor: 3,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B_select_floor3',
    nrId: 43,
  },
  {
    building: 'M3',
    number: 14,
    type: 'M3A',
    floor: 3,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_A_select_floor3',
    nrId: 44,
  },
  {
    building: 'M3',
    number: 15,
    type: 'M3B1',
    floor: 3,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B1_select_floor3',
    nrId: 45,
  },
  {
    building: 'M3',
    number: 16,
    type: 'M3D',
    floor: 4,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor4',
    nrId: 46,
  },
  {
    building: 'M3',
    number: 17,
    type: 'M3D1',
    floor: 4,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D1_select_floor4',
    nrId: 47,
  },
  {
    building: 'M3',
    number: 18,
    type: 'M3B',
    floor: 4,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B_select_floor4',
    nrId: 48,
  },
  {
    building: 'M3',
    number: 20,
    type: 'M3B1',
    floor: 4,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B1_select_floor4',
    nrId: 49,
  },
  {
    building: 'M3',
    number: 21,
    type: 'M3D',
    floor: 5,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 50,
  },
  {
    building: 'M3',
    number: 22,
    type: 'M3D1',
    floor: 5,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D1_select_floor5',
    nrId: 51,
  },
  {
    building: 'M3',
    number: 23,
    type: 'M3B',
    floor: 5,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_B_select_floor5',
    nrId: 52,
  },
  {
    building: 'M3',
    number: 26,
    type: 'M3D',
    floor: 6,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 53,
  },
  {
    building: 'M3',
    number: 27,
    type: 'M3D1',
    floor: 6,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D1_select_floor6',
    nrId: 54,
  },
  {
    building: 'M3',
    number: 31,
    type: 'M3D',
    floor: 7,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 55,
  },
  {
    building: 'M3',
    number: 32,
    type: 'M3D1',
    floor: 7,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D1_select_floor7',
    nrId: 56,
  },
  {
    building: 'M3',
    number: 36,
    type: 'M3D',
    floor: 8,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 57,
  },
  {
    building: 'M3',
    number: 37,
    type: 'M3D1',
    floor: 8,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D1_select_floor8',
    nrId: 58,
  },
  {
    building: 'S1',
    number: 3,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 59,
  },
  {
    building: 'S1',
    number: 4,
    type: 'B',
    floor: 1,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_B_select_floor1',
    nrId: 60,
  },
  {
    building: 'S1',
    number: 5,
    type: 'C',
    floor: 1,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_C_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 61,
  },
  {
    building: 'S1',
    number: 6,
    type: 'D',
    floor: 1,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_D_select_floor1',
    nrId: 62,
  },
  {
    building: 'S1',
    number: 7,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 63,
  },
  {
    building: 'S1',
    number: 8,
    type: 'B',
    floor: 2,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_B_select_floor2',
    nrId: 64,
  },
  {
    building: 'S1',
    number: 9,
    type: 'C',
    floor: 2,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_C_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 65,
  },
  {
    building: 'S1',
    number: 10,
    type: 'D',
    floor: 2,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_D_select_floor2',
    nrId: 66,
  },
  {
    building: 'S1',
    number: 11,
    type: 'A',
    floor: 3,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_A_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 67,
  },
  {
    building: 'S1',
    number: 12,
    type: 'B',
    floor: 3,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_B_select_floor3',
    nrId: 68,
  },
  {
    building: 'S1',
    number: 13,
    type: 'C',
    floor: 3,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_C_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 69,
  },
  {
    building: 'S1',
    number: 14,
    type: 'D',
    floor: 3,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_D_select_floor3',
    nrId: 70,
  },
  {
    building: 'S1',
    number: 15,
    type: 'A',
    floor: 4,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_A_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 71,
  },
  {
    building: 'S1',
    number: 16,
    type: 'B',
    floor: 4,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_B_select_floor4',
    nrId: 72,
  },
  {
    building: 'S1',
    number: 17,
    type: 'C',
    floor: 4,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_C_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 73,
  },
  {
    building: 'S1',
    number: 21,
    type: 'C',
    floor: 5,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_C_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 74,
  },
  {
    building: 'S2',
    number: 3,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 75,
  },
  {
    building: 'S2',
    number: 4,
    type: 'B',
    floor: 1,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_B_select_floor1',
    nrId: 76,
  },
  {
    building: 'S2',
    number: 5,
    type: 'C',
    floor: 1,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_C_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 77,
  },
  {
    building: 'S2',
    number: 6,
    type: 'D',
    floor: 1,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_D_select_floor1',
    nrId: 78,
  },
  {
    building: 'S2',
    number: 7,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 79,
  },
  {
    building: 'S2',
    number: 8,
    type: 'B',
    floor: 2,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_B_select_floor2',
    nrId: 80,
  },
  {
    building: 'S2',
    number: 9,
    type: 'C',
    floor: 2,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_C_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 81,
  },
  {
    building: 'S2',
    number: 10,
    type: 'D',
    floor: 2,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_D_select_floor2',
    nrId: 82,
  },
  {
    building: 'S2',
    number: 11,
    type: 'A',
    floor: 3,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_A_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 83,
  },
  {
    building: 'S2',
    number: 12,
    type: 'B',
    floor: 3,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_B_select_floor3',
    nrId: 84,
  },
  {
    building: 'S2',
    number: 13,
    type: 'C',
    floor: 3,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_C_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 85,
  },
  {
    building: 'S2',
    number: 14,
    type: 'D',
    floor: 3,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_D_select_floor3',
    nrId: 86,
  },
  {
    building: 'S2',
    number: 15,
    type: 'A',
    floor: 4,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_A_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 87,
  },
  {
    building: 'S2',
    number: 16,
    type: 'B',
    floor: 4,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_B_select_floor4',
    nrId: 88,
  },
  {
    building: 'S2',
    number: 17,
    type: 'C',
    floor: 4,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_C_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 89,
  },
  {
    building: 'S2',
    number: 21,
    type: 'C',
    floor: 5,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_C_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 90,
  },
  {
    building: 'S3',
    number: 3,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 91,
  },
  {
    building: 'S3',
    number: 4,
    type: 'B',
    floor: 1,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_B_select_floor1',
    nrId: 92,
  },
  {
    building: 'S3',
    number: 5,
    type: 'C',
    floor: 1,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_C_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 93,
  },
  {
    building: 'S3',
    number: 6,
    type: 'D',
    floor: 1,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_D_select_floor1',
    nrId: 94,
  },
  {
    building: 'S3',
    number: 7,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 95,
  },
  {
    building: 'S3',
    number: 8,
    type: 'B',
    floor: 2,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_B_select_floor2',
    nrId: 96,
  },
  {
    building: 'S3',
    number: 9,
    type: 'C',
    floor: 2,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_C_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 97,
  },
  {
    building: 'S3',
    number: 10,
    type: 'D',
    floor: 2,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_D_select_floor2',
    nrId: 98,
  },
  {
    building: 'S3',
    number: 11,
    type: 'A',
    floor: 3,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_A_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 99,
  },
  {
    building: 'S3',
    number: 12,
    type: 'B',
    floor: 3,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_B_select_floor3',
    nrId: 100,
  },
  {
    building: 'S3',
    number: 13,
    type: 'C',
    floor: 3,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_C_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 101,
  },
  {
    building: 'S3',
    number: 14,
    type: 'D',
    floor: 3,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_D_select_floor3',
    nrId: 102,
  },
  {
    building: 'S3',
    number: 15,
    type: 'A',
    floor: 4,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_A_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 103,
  },
  {
    building: 'S3',
    number: 16,
    type: 'B',
    floor: 4,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_B_select_floor4',
    nrId: 104,
  },
  {
    building: 'S3',
    number: 17,
    type: 'C',
    floor: 4,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_C_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 105,
  },
  {
    building: 'S3',
    number: 21,
    type: 'C',
    floor: 5,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_C_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 106,
  },
  {
    building: 'S4',
    number: 3,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 107,
  },
  {
    building: 'S4',
    number: 4,
    type: 'B',
    floor: 1,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_B_select_floor1',
    nrId: 108,
  },
  {
    building: 'S4',
    number: 5,
    type: 'C',
    floor: 1,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_C_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 109,
  },
  {
    building: 'S4',
    number: 6,
    type: 'D',
    floor: 1,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_D_select_floor1',
    nrId: 110,
  },
  {
    building: 'S4',
    number: 7,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 111,
  },
  {
    building: 'S4',
    number: 8,
    type: 'B',
    floor: 2,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_B_select_floor2',
    nrId: 112,
  },
  {
    building: 'S4',
    number: 9,
    type: 'C',
    floor: 2,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_C_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 113,
  },
  {
    building: 'S4',
    number: 10,
    type: 'D',
    floor: 2,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_D_select_floor2',
    nrId: 114,
  },
  {
    building: 'S4',
    number: 11,
    type: 'A',
    floor: 3,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_A_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 115,
  },
  {
    building: 'S4',
    number: 12,
    type: 'B',
    floor: 3,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_B_select_floor3',
    nrId: 116,
  },
  {
    building: 'S4',
    number: 13,
    type: 'C',
    floor: 3,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_C_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 117,
  },
  {
    building: 'S4',
    number: 14,
    type: 'D',
    floor: 3,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_D_select_floor3',
    nrId: 118,
  },
  {
    building: 'S4',
    number: 15,
    type: 'A',
    floor: 4,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_A_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 119,
  },
  {
    building: 'S4',
    number: 16,
    type: 'B',
    floor: 4,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_B_select_floor4',
    nrId: 120,
  },
  {
    building: 'S4',
    number: 17,
    type: 'C',
    floor: 4,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_C_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 121,
  },
  {
    building: 'S4',
    number: 21,
    type: 'C',
    floor: 5,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_C_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 122,
  },
  {
    building: 'S5',
    number: 2,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 123,
  },
  {
    building: 'S5',
    number: 3,
    type: 'B',
    floor: 1,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_B_select_floor1',
    nrId: 124,
  },
  {
    building: 'S5',
    number: 4,
    type: 'C',
    floor: 1,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_C_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 125,
  },
  {
    building: 'S5',
    number: 5,
    type: 'D',
    floor: 1,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_D_select_floor1',
    nrId: 126,
  },
  {
    building: 'S5',
    number: 6,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 127,
  },
  {
    building: 'S5',
    number: 7,
    type: 'B',
    floor: 2,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_B_select_floor2',
    nrId: 128,
  },
  {
    building: 'S5',
    number: 8,
    type: 'C',
    floor: 2,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_C_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 129,
  },
  {
    building: 'S5',
    number: 9,
    type: 'D',
    floor: 2,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_D_select_floor2',
    nrId: 130,
  },
  {
    building: 'S5',
    number: 10,
    type: 'A',
    floor: 3,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_A_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 131,
  },
  {
    building: 'S5',
    number: 11,
    type: 'B',
    floor: 3,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_B_select_floor3',
    nrId: 132,
  },
  {
    building: 'S5',
    number: 12,
    type: 'C',
    floor: 3,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_C_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 133,
  },
  {
    building: 'S5',
    number: 13,
    type: 'D',
    floor: 3,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_D_select_floor3',
    nrId: 134,
  },
  {
    building: 'S5',
    number: 14,
    type: 'A',
    floor: 4,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_A_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 135,
  },
  {
    building: 'S5',
    number: 15,
    type: 'B',
    floor: 4,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_B_select_floor4',
    nrId: 136,
  },
  {
    building: 'S5',
    number: 16,
    type: 'C',
    floor: 4,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_C_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 137,
  },
  {
    building: 'S6',
    number: 2,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 138,
  },
  {
    building: 'S6',
    number: 3,
    type: 'B',
    floor: 1,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_B_select_floor1',
    nrId: 139,
  },
  {
    building: 'S6',
    number: 4,
    type: 'C',
    floor: 1,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_C_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 140,
  },
  {
    building: 'S6',
    number: 5,
    type: 'D',
    floor: 1,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_D_select_floor1',
    nrId: 141,
  },
  {
    building: 'S6',
    number: 6,
    type: 'A',
    floor: 2,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_A_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 142,
  },
  {
    building: 'S6',
    number: 7,
    type: 'B',
    floor: 2,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_B_select_floor2',
    nrId: 143,
  },
  {
    building: 'S6',
    number: 8,
    type: 'C',
    floor: 2,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_C_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 144,
  },
  {
    building: 'S6',
    number: 9,
    type: 'D',
    floor: 2,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_D_select_floor2',
    nrId: 145,
  },
  {
    building: 'S6',
    number: 10,
    type: 'A',
    floor: 3,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_A_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 146,
  },
  {
    building: 'S6',
    number: 11,
    type: 'B',
    floor: 3,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_B_select_floor3',
    nrId: 147,
  },
  {
    building: 'S6',
    number: 12,
    type: 'C',
    floor: 3,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_C_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 148,
  },
  {
    building: 'S6',
    number: 13,
    type: 'D',
    floor: 3,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_D_select_floor3',
    nrId: 149,
  },
  {
    building: 'S6',
    number: 14,
    type: 'A',
    floor: 4,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_A_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 150,
  },
  {
    building: 'S6',
    number: 16,
    type: 'C',
    floor: 4,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S6_C_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 151,
  },
  {
    building: 'M2',
    number: 19,
    type: 'M2A',
    floor: 4,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor4',
    nrId: 152,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 24,
    type: 'M2A',
    floor: 5,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor5',
    nrId: 153,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 28,
    type: 'M2B',
    floor: 6,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B_select_floor6',
    nrId: 154,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M2',
    number: 29,
    type: 'M2A',
    floor: 6,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor6',
    nrId: 155,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 30,
    type: 'M2B1',
    floor: 6,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor6',
    nrId: 156,
  },
  {
    building: 'M2',
    number: 33,
    type: 'M2B',
    floor: 7,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B_select_floor7',
    nrId: 157,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M2',
    number: 34,
    type: 'M2A',
    floor: 7,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor7',
    nrId: 158,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 35,
    type: 'M2B1',
    floor: 7,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor7',
    nrId: 159,
  },
  {
    building: 'M2',
    number: 38,
    type: 'M2B',
    floor: 8,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B_select_floor8',
    nrId: 160,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M2',
    number: 39,
    type: 'M2A',
    floor: 8,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor8',
    nrId: 161,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 40,
    type: 'M2B1',
    floor: 8,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor8',
    nrId: 162,
  },
  {
    building: 'M2',
    number: 42,
    type: 'M2D1',
    floor: 9,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D1_select_floor9',
    nrId: 163,
  },
  {
    building: 'M2',
    number: 43,
    type: 'M2B',
    floor: 9,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B_select_floor9',
    nrId: 164,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M2',
    number: 44,
    type: 'M2A',
    floor: 9,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor9',
    nrId: 165,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 45,
    type: 'M2B1',
    floor: 9,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor9',
    nrId: 166,
  },
  {
    building: 'M2',
    number: 46,
    type: 'M2D',
    floor: 10,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D_select_floor10',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 167,
  },
  {
    building: 'M2',
    number: 47,
    type: 'M2D1',
    floor: 10,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D1_select_floor10',
    nrId: 168,
  },
  {
    building: 'M2',
    number: 48,
    type: 'M2B',
    floor: 10,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B_select_floor10',
    nrId: 169,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M2',
    number: 49,
    type: 'M2A',
    floor: 10,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor10',
    nrId: 170,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 50,
    type: 'M2B1',
    floor: 10,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor10',
    nrId: 171,
  },
  {
    building: 'M2',
    number: 51,
    type: 'M2D',
    floor: 11,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D_select_floor11',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 172,
  },
  {
    building: 'M2',
    number: 52,
    type: 'M2D1',
    floor: 11,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D1_select_floor11',
    nrId: 173,
  },
  {
    building: 'M2',
    number: 53,
    type: 'M2B',
    floor: 11,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B_select_floor11',
    nrId: 174,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M2',
    number: 54,
    type: 'M2A',
    floor: 11,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor11',
    nrId: 175,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 55,
    type: 'M2B1',
    floor: 11,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor11',
    nrId: 176,
  },
  {
    building: 'M2',
    number: 56,
    type: 'M2D',
    floor: 12,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_D_select_floor12',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 177,
  },
  {
    building: 'M2',
    number: 57,
    type: 'M2D1',
    floor: 12,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D1_select_floor12',
    nrId: 178,
  },
  {
    building: 'M2',
    number: 58,
    type: 'M2B',
    floor: 12,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B_select_floor12',
    nrId: 179,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M2',
    number: 59,
    type: 'M2A',
    floor: 12,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor12',
    nrId: 180,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 60,
    type: 'M2B1',
    floor: 12,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor12',
    nrId: 181,
  },
  {
    building: 'M2',
    number: 61,
    type: 'M2D',
    floor: 13,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D_select_floor13',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 182,
  },
  {
    building: 'M2',
    number: 62,
    type: 'M2D1',
    floor: 13,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D1_select_floor13',
    nrId: 183,
  },
  {
    building: 'M2',
    number: 63,
    type: 'M2B',
    floor: 13,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M2_B_select_floor13',
    nrId: 184,
  },
  {
    building: 'M2',
    number: 64,
    type: 'M2A',
    floor: 13,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor13',
    nrId: 185,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M2',
    number: 65,
    type: 'M2B1',
    floor: 13,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor13',
    nrId: 186,
  },
  {
    building: 'M2',
    number: 66,
    type: 'M2D',
    floor: 14,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D_select_floor14',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 187,
  },
  {
    building: 'M2',
    number: 67,
    type: 'M2D1',
    floor: 14,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_D1_select_floor14',
    nrId: 188,
  },
  {
    building: 'M2',
    number: 68,
    type: 'M2B',
    floor: 14,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B_select_floor14',
    nrId: 189,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M2',
    number: 69,
    type: 'M2A',
    floor: 14,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_A_select_floor14',
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
    nrId: 190,
  },
  {
    building: 'M2',
    number: 70,
    type: 'M2B1',
    floor: 14,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_B1_select_floor14',
    nrId: 191,
  },
  {
    building: 'M2',
    number: 71,
    type: 'M2E',
    floor: 15,
    rooms: 6,
    area: 160.65,
    balconyArea: 134.61,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_E_select_floor15',
    nrId: 192,
  },
  {
    building: 'M2',
    number: 72,
    type: 'M2E1',
    floor: 15,
    rooms: 6,
    area: 160.65,
    balconyArea: 133.18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_E1_select_floor15',
    nrId: 193,
  },
  {
    building: 'M2',
    number: 73,
    type: 'M2F',
    floor: 16,
    rooms: 5,
    area: 132.32,
    balconyArea: 46.78,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_F_select_floor16',
    nrId: 194,
  },
  {
    building: 'M2',
    number: 74,
    type: 'M2F1',
    floor: 16,
    rooms: 5,
    area: 132.32,
    balconyArea: 46.78,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M2_F1_select_floor16',
    nrId: 195,
  },
  {
    building: 'M3',
    number: 19,
    type: 'M3A',
    floor: 4,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor4',
    nrId: 196,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 24,
    type: 'M3A',
    floor: 5,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor5',
    nrId: 197,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 25,
    type: 'M3B1',
    floor: 5,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor5',
    nrId: 198,
  },
  {
    building: 'M3',
    number: 28,
    type: 'M3B',
    floor: 6,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor6',
    nrId: 199,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 29,
    type: 'M3A',
    floor: 6,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor6',
    nrId: 200,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 30,
    type: 'M3B1',
    floor: 6,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor6',
    nrId: 201,
  },
  {
    building: 'M3',
    number: 33,
    type: 'M3B',
    floor: 7,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor7',
    nrId: 202,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 34,
    type: 'M3A',
    floor: 7,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor7',
    nrId: 203,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 35,
    type: 'M3B1',
    floor: 7,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor7',
    nrId: 204,
  },
  {
    building: 'M3',
    number: 38,
    type: 'M3B',
    floor: 8,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor8',
    nrId: 205,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 39,
    type: 'M3A',
    floor: 8,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor8',
    nrId: 206,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 40,
    type: 'M3B1',
    floor: 8,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor8',
    nrId: 207,
  },
  {
    building: 'M3',
    number: 41,
    type: 'M3D',
    floor: 9,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D_select_floor9',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 208,
  },
  {
    building: 'M3',
    number: 42,
    type: 'M3D1',
    floor: 9,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D1_select_floor9',
    nrId: 209,
  },
  {
    building: 'M3',
    number: 43,
    type: 'M3B',
    floor: 9,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor9',
    nrId: 210,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 44,
    type: 'M3A',
    floor: 9,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor9',
    nrId: 211,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 45,
    type: 'M3B1',
    floor: 9,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor9',
    nrId: 212,
  },
  {
    building: 'M3',
    number: 46,
    type: 'M3D',
    floor: 10,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D_select_floor10',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 213,
  },
  {
    building: 'M3',
    number: 47,
    type: 'M3D1',
    floor: 10,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D1_select_floor10',
    nrId: 214,
  },
  {
    building: 'M3',
    number: 48,
    type: 'M3B',
    floor: 10,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor10',
    nrId: 215,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 49,
    type: 'M3A',
    floor: 10,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor10',
    nrId: 216,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 50,
    type: 'M3B1',
    floor: 10,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor10',
    nrId: 217,
  },
  {
    building: 'M3',
    number: 51,
    type: 'M3D',
    floor: 11,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D_select_floor11',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 218,
  },
  {
    building: 'M3',
    number: 52,
    type: 'M3D1',
    floor: 11,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D1_select_floor11',
    nrId: 219,
  },
  {
    building: 'M3',
    number: 53,
    type: 'M3B',
    floor: 11,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor11',
    nrId: 220,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 54,
    type: 'M3A',
    floor: 11,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor11',
    nrId: 221,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 55,
    type: 'M3B1',
    floor: 11,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor11',
    nrId: 222,
  },
  {
    building: 'M3',
    number: 56,
    type: 'M3D',
    floor: 12,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D_select_floor12',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 223,
  },
  {
    building: 'M3',
    number: 57,
    type: 'M3D1',
    floor: 12,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D1_select_floor12',
    nrId: 224,
  },
  {
    building: 'M3',
    number: 58,
    type: 'M3B',
    floor: 12,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor12',
    nrId: 225,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 59,
    type: 'M3A',
    floor: 12,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor12',
    nrId: 226,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 60,
    type: 'M3B1',
    floor: 12,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor12',
    nrId: 227,
  },
  {
    building: 'M3',
    number: 61,
    type: 'M3D',
    floor: 13,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D_select_floor13',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 228,
  },
  {
    building: 'M3',
    number: 62,
    type: 'M3D1',
    floor: 13,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D1_select_floor13',
    nrId: 229,
  },
  {
    building: 'M3',
    number: 63,
    type: 'M3B',
    floor: 13,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor13',
    nrId: 230,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 64,
    type: 'M3A',
    floor: 13,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor13',
    nrId: 231,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 65,
    type: 'M3B1',
    floor: 13,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor13',
    nrId: 232,
  },
  {
    building: 'M3',
    number: 66,
    type: 'M3D',
    floor: 14,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'M3_D_select_floor14',
    tourUrl: 'https://my.treedis.com/tour/md55rooms',
    nrId: 233,
  },
  {
    building: 'M3',
    number: 67,
    type: 'M3D1',
    floor: 14,
    rooms: 5.5,
    area: 133.32,
    balconyArea: 18.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_D1_select_floor14',
    nrId: 234,
  },
  {
    building: 'M3',
    number: 68,
    type: 'M3B',
    floor: 14,
    rooms: 4,
    area: 100.93,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B_select_floor14',
    nrId: 235,
    tourUrl: 'https://my.treedis.com/tour/mb4rooms',
  },
  {
    building: 'M3',
    number: 69,
    type: 'M3A',
    floor: 14,
    rooms: 3,
    area: 78.6,
    balconyArea: 11.04,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_A_select_floor14',
    nrId: 236,
    tourUrl: 'https://my.treedis.com/tour/ma3rooms',
  },
  {
    building: 'M3',
    number: 70,
    type: 'M3B1',
    floor: 14,
    rooms: 4,
    area: 100.71,
    balconyArea: 14.26,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_B1_select_floor14',
    nrId: 237,
  },
  {
    building: 'M3',
    number: 71,
    type: 'M3E',
    floor: 15,
    rooms: 6,
    area: 160.65,
    balconyArea: 134.61,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_E_select_floor15',
    nrId: 238,
  },
  {
    building: 'M3',
    number: 72,
    type: 'M3E1',
    floor: 15,
    rooms: 6,
    area: 160.65,
    balconyArea: 133.18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_E1_select_floor15',
    nrId: 239,
  },
  {
    building: 'M3',
    number: 73,
    type: 'M3F',
    floor: 16,
    rooms: 5,
    area: 132.32,
    balconyArea: 46.78,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_F_select_floor16',
    nrId: 240,
  },
  {
    building: 'M3',
    number: 74,
    type: 'M3F1',
    floor: 16,
    rooms: 5,
    area: 132.32,
    balconyArea: 46.78,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'M3_F1_select_floor16',
    nrId: 241,
  },
  {
    building: 'S1',
    number: 2,
    type: 'BG',
    floor: 0,
    rooms: 3,
    area: 77.87,
    balconyArea: 69.01,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S1_BG_select_ground',
    nrId: 243,
  },
  {
    building: 'S1',
    number: 18,
    type: 'D',
    floor: 4,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_D_select_floor4',
    nrId: 244,
  },
  {
    building: 'S1',
    number: 19,
    type: 'A',
    floor: 5,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_A_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 245,
  },
  {
    building: 'S1',
    number: 20,
    type: 'B',
    floor: 5,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_B_select_floor5',
    nrId: 246,
  },
  {
    building: 'S1',
    number: 22,
    type: 'D',
    floor: 5,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_D_select_floor5',
    nrId: 247,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S1',
    number: 23,
    type: 'A',
    floor: 6,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_A_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 248,
  },
  {
    building: 'S1',
    number: 24,
    type: 'B',
    floor: 6,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_B_select_floor6',
    nrId: 249,
  },
  {
    building: 'S1',
    number: 25,
    type: 'C',
    floor: 6,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_C_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 250,
  },
  {
    building: 'S1',
    number: 26,
    type: 'D',
    floor: 6,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_D_select_floor6',
    nrId: 251,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S1',
    number: 27,
    type: 'A',
    floor: 7,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_A_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 252,
  },
  {
    building: 'S1',
    number: 28,
    type: 'B',
    floor: 7,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_B_select_floor7',
    nrId: 253,
  },
  {
    building: 'S1',
    number: 29,
    type: 'C',
    floor: 7,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_C_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 254,
  },
  {
    building: 'S1',
    number: 30,
    type: 'D',
    floor: 7,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_D_select_floor7',
    nrId: 255,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S1',
    number: 31,
    type: 'A',
    floor: 8,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_A_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 256,
  },
  {
    building: 'S1',
    number: 32,
    type: 'B',
    floor: 8,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_B_select_floor8',
    nrId: 257,
  },
  {
    building: 'S1',
    number: 33,
    type: 'C',
    floor: 8,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_C_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 258,
  },
  {
    building: 'S1',
    number: 34,
    type: 'D',
    floor: 8,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_D_select_floor8',
    nrId: 259,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S1',
    number: 35,
    type: 'E',
    floor: 9,
    rooms: 6,
    area: 153.52,
    balconyArea: 78.2,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_E_select_floor9',
    nrId: 260,
  },
  {
    building: 'S1',
    number: 36,
    type: 'F',
    floor: 9,
    rooms: 6,
    area: 142.42,
    balconyArea: 89.71,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S1_F_select_floor9',
    tourUrl: 'https://my.treedis.com/tour/e688994f',
    nrId: 261,
    kind: 'penthouse',
  },
  {
    building: 'S2',
    number: 1,
    type: 'DG',
    floor: 0,
    rooms: 5,
    area: 120.69,
    balconyArea: 132.33,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_DG_select_ground',
    nrId: 262,
  },
  {
    building: 'S2',
    number: 2,
    type: 'BG',
    floor: 0,
    rooms: 3,
    area: 77.87,
    balconyArea: 92.63,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S2_BG_select_ground',
    nrId: 263,
  },
  {
    building: 'S2',
    number: 18,
    type: 'D',
    floor: 4,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_D_select_floor4',
    nrId: 264,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S2',
    number: 19,
    type: 'A',
    floor: 5,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_A_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 265,
  },
  {
    building: 'S2',
    number: 20,
    type: 'B',
    floor: 5,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_B_select_floor5',
    nrId: 266,
  },
  {
    building: 'S2',
    number: 22,
    type: 'D',
    floor: 5,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_D_select_floor5',
    nrId: 267,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S2',
    number: 23,
    type: 'A',
    floor: 6,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_A_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 268,
  },
  {
    building: 'S2',
    number: 24,
    type: 'B',
    floor: 6,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_B_select_floor6',
    nrId: 269,
  },
  {
    building: 'S2',
    number: 25,
    type: 'C',
    floor: 6,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_C_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 270,
  },
  {
    building: 'S2',
    number: 26,
    type: 'D',
    floor: 6,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_D_select_floor6',
    nrId: 271,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S2',
    number: 27,
    type: 'A',
    floor: 7,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_A_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 272,
  },
  {
    building: 'S2',
    number: 28,
    type: 'B',
    floor: 7,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_B_select_floor7',
    nrId: 273,
  },
  {
    building: 'S2',
    number: 29,
    type: 'C',
    floor: 7,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_C_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 274,
  },
  {
    building: 'S2',
    number: 30,
    type: 'D',
    floor: 7,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_D_select_floor7',
    nrId: 275,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S2',
    number: 31,
    type: 'A',
    floor: 8,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_A_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 276,
  },
  {
    building: 'S2',
    number: 32,
    type: 'B',
    floor: 8,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_B_select_floor8',
    nrId: 277,
  },
  {
    building: 'S2',
    number: 33,
    type: 'C',
    floor: 8,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_C_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 278,
  },
  {
    building: 'S2',
    number: 34,
    type: 'D',
    floor: 8,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_D_select_floor8',
    nrId: 279,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S2',
    number: 35,
    type: 'E',
    floor: 9,
    rooms: 6,
    area: 153.52,
    balconyArea: 78.2,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_E_select_floor9',
    nrId: 280,
  },
  {
    building: 'S2',
    number: 36,
    type: 'F',
    floor: 9,
    rooms: 6,
    area: 142.42,
    balconyArea: 89.71,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S2_F_select_floor9',
    nrId: 281,
    tourUrl: 'https://my.treedis.com/tour/e688994f',
    kind: 'penthouse',
  },
  {
    building: 'S3',
    number: 1,
    type: 'DG',
    floor: 0,
    rooms: 5,
    area: 120.69,
    balconyArea: 132.33,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_DG_select_ground',
    nrId: 282,
  },
  {
    building: 'S3',
    number: 2,
    type: 'BG',
    floor: 0,
    rooms: 3,
    area: 77.87,
    balconyArea: 92.63,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S3_BG_select_ground',
    nrId: 283,
  },
  {
    building: 'S3',
    number: 18,
    type: 'D',
    floor: 4,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_D_select_floor4',
    nrId: 284,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S3',
    number: 19,
    type: 'A',
    floor: 5,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_A_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 285,
  },
  {
    building: 'S3',
    number: 20,
    type: 'B',
    floor: 5,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_B_select_floor5',
    nrId: 286,
  },
  {
    building: 'S3',
    number: 22,
    type: 'D',
    floor: 5,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_D_select_floor5',
    nrId: 287,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S3',
    number: 23,
    type: 'A',
    floor: 6,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_A_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 288,
  },
  {
    building: 'S3',
    number: 24,
    type: 'B',
    floor: 6,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_B_select_floor6',
    nrId: 289,
  },
  {
    building: 'S3',
    number: 25,
    type: 'C',
    floor: 6,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_C_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 290,
  },
  {
    building: 'S3',
    number: 26,
    type: 'D',
    floor: 6,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_D_select_floor6',
    nrId: 291,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S3',
    number: 27,
    type: 'A',
    floor: 7,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_A_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 292,
  },
  {
    building: 'S3',
    number: 28,
    type: 'B',
    floor: 7,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_B_select_floor7',
    nrId: 293,
  },
  {
    building: 'S3',
    number: 29,
    type: 'C',
    floor: 7,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_C_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 294,
  },
  {
    building: 'S3',
    number: 30,
    type: 'D',
    floor: 7,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_D_select_floor7',
    nrId: 295,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S3',
    number: 31,
    type: 'A',
    floor: 8,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_A_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 296,
  },
  {
    building: 'S3',
    number: 32,
    type: 'B',
    floor: 8,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_B_select_floor8',
    nrId: 297,
  },
  {
    building: 'S3',
    number: 33,
    type: 'C',
    floor: 8,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_C_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 298,
  },
  {
    building: 'S3',
    number: 34,
    type: 'D',
    floor: 8,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_D_select_floor8',
    nrId: 299,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S3',
    number: 35,
    type: 'E',
    floor: 9,
    rooms: 6,
    area: 153.52,
    balconyArea: 78.2,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_E_select_floor9',
    nrId: 300,
  },
  {
    building: 'S3',
    number: 36,
    type: 'F',
    floor: 9,
    rooms: 6,
    area: 142.42,
    balconyArea: 89.71,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S3_F_select_floor9',
    nrId: 301,
    tourUrl: 'https://my.treedis.com/tour/e688994f',
    kind: 'penthouse',
  },
  {
    building: 'S4',
    number: 1,
    type: 'DG',
    floor: 0,
    rooms: 5,
    area: 120.69,
    balconyArea: 132.34,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_DG_select_ground',
    nrId: 302,
  },
  {
    building: 'S4',
    number: 2,
    type: 'BG',
    floor: 0,
    rooms: 3,
    area: 77.87,
    balconyArea: 96.68,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S4_BG_select_ground',
    nrId: 303,
  },
  {
    building: 'S4',
    number: 18,
    type: 'D',
    floor: 4,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_D_select_floor4',
    nrId: 304,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S4',
    number: 19,
    type: 'A',
    floor: 5,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_A_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 305,
  },
  {
    building: 'S4',
    number: 20,
    type: 'B',
    floor: 5,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_B_select_floor5',
    nrId: 306,
  },
  {
    building: 'S4',
    number: 22,
    type: 'D',
    floor: 5,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_D_select_floor5',
    nrId: 307,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S4',
    number: 23,
    type: 'A',
    floor: 6,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_A_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 308,
  },
  {
    building: 'S4',
    number: 24,
    type: 'B',
    floor: 6,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_B_select_floor6',
    nrId: 309,
  },
  {
    building: 'S4',
    number: 25,
    type: 'C',
    floor: 6,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_C_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 310,
  },
  {
    building: 'S4',
    number: 26,
    type: 'D',
    floor: 6,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_D_select_floor6',
    nrId: 311,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S4',
    number: 27,
    type: 'A',
    floor: 7,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_A_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 312,
  },
  {
    building: 'S4',
    number: 28,
    type: 'B',
    floor: 7,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_B_select_floor7',
    nrId: 313,
  },
  {
    building: 'S4',
    number: 29,
    type: 'C',
    floor: 7,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_C_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 314,
  },
  {
    building: 'S4',
    number: 30,
    type: 'D',
    floor: 7,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_D_select_floor7',
    nrId: 315,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S4',
    number: 31,
    type: 'A',
    floor: 8,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_A_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 316,
  },
  {
    building: 'S4',
    number: 32,
    type: 'B',
    floor: 8,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_B_select_floor8',
    nrId: 317,
  },
  {
    building: 'S4',
    number: 33,
    type: 'C',
    floor: 8,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_C_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 318,
  },
  {
    building: 'S4',
    number: 34,
    type: 'D',
    floor: 8,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_D_select_floor8',
    nrId: 319,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S4',
    number: 35,
    type: 'E',
    floor: 9,
    rooms: 6,
    area: 153.52,
    balconyArea: 78.2,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_E_select_floor9',
    nrId: 320,
  },
  {
    building: 'S4',
    number: 36,
    type: 'F',
    floor: 9,
    rooms: 6,
    area: 142.42,
    balconyArea: 89.71,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S4_F_select_floor9',
    nrId: 321,
    tourUrl: 'https://my.treedis.com/tour/sf6rooms',
    kind: 'penthouse',
  },
  {
    building: 'S5',
    number: 1,
    type: 'DG',
    floor: 0,
    rooms: 5,
    area: 120.69,
    balconyArea: 138.68,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_DG_select_ground',
    nrId: 322,
  },
  {
    building: 'S5',
    number: 17,
    type: 'D',
    floor: 4,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_D_select_floor4',
    nrId: 323,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S5',
    number: 18,
    type: 'A',
    floor: 5,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_A_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 324,
  },
  {
    building: 'S5',
    number: 19,
    type: 'B',
    floor: 5,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_B_select_floor5',
    nrId: 325,
  },
  {
    building: 'S5',
    number: 20,
    type: 'C',
    floor: 5,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_C_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 326,
  },
  {
    building: 'S5',
    number: 21,
    type: 'D',
    floor: 5,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_D_select_floor5',
    nrId: 327,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S5',
    number: 22,
    type: 'A',
    floor: 6,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_A_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 328,
  },
  {
    building: 'S5',
    number: 23,
    type: 'B',
    floor: 6,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_B_select_floor6',
    nrId: 329,
  },
  {
    building: 'S5',
    number: 24,
    type: 'C',
    floor: 6,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_C_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 330,
  },
  {
    building: 'S5',
    number: 25,
    type: 'D',
    floor: 6,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_D_select_floor6',
    nrId: 331,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S5',
    number: 26,
    type: 'A',
    floor: 7,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_A_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 332,
  },
  {
    building: 'S5',
    number: 27,
    type: 'B',
    floor: 7,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_B_select_floor7',
    nrId: 333,
  },
  {
    building: 'S5',
    number: 28,
    type: 'C',
    floor: 7,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_C_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 334,
  },
  {
    building: 'S5',
    number: 29,
    type: 'D',
    floor: 7,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_D_select_floor7',
    nrId: 335,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S5',
    number: 30,
    type: 'A',
    floor: 8,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_A_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 336,
  },
  {
    building: 'S5',
    number: 31,
    type: 'B',
    floor: 8,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_B_select_floor8',
    nrId: 337,
  },
  {
    building: 'S5',
    number: 32,
    type: 'C',
    floor: 8,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_C_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 338,
  },
  {
    building: 'S5',
    number: 33,
    type: 'D',
    floor: 8,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_D_select_floor8',
    nrId: 339,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S5',
    number: 34,
    type: 'E',
    floor: 9,
    rooms: 6,
    area: 153.52,
    balconyArea: 78.2,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S5_E_select_floor9',
    nrId: 340,
  },
  {
    building: 'S5',
    number: 35,
    type: 'F',
    floor: 9,
    rooms: 6,
    area: 142.42,
    balconyArea: 89.71,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'S5_F_select_floor9',
    nrId: 341,
  },
  {
    building: 'S6',
    number: 1,
    type: 'DG',
    floor: 0,
    rooms: 5,
    area: 120.69,
    balconyArea: 94.74,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_DG_select_ground',
    nrId: 342,
  },
  {
    building: 'S6',
    number: 15,
    type: 'B',
    floor: 4,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_B_select_floor4',
    nrId: 343,
  },
  {
    building: 'S6',
    number: 17,
    type: 'D',
    floor: 4,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_D_select_floor4',
    nrId: 344,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S6',
    number: 18,
    type: 'A',
    floor: 5,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_A_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 345,
  },
  {
    building: 'S6',
    number: 19,
    type: 'B',
    floor: 5,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_B_select_floor5',
    nrId: 346,
  },
  {
    building: 'S6',
    number: 20,
    type: 'C',
    floor: 5,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_C_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 347,
  },
  {
    building: 'S6',
    number: 21,
    type: 'D',
    floor: 5,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_D_select_floor5',
    nrId: 348,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S6',
    number: 22,
    type: 'A',
    floor: 6,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_A_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 349,
  },
  {
    building: 'S6',
    number: 23,
    type: 'B',
    floor: 6,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_B_select_floor6',
    nrId: 350,
  },
  {
    building: 'S6',
    number: 24,
    type: 'C',
    floor: 6,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_C_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 351,
  },
  {
    building: 'S6',
    number: 25,
    type: 'D',
    floor: 6,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_D_select_floor6',
    nrId: 352,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S6',
    number: 26,
    type: 'A',
    floor: 7,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_A_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 353,
  },
  {
    building: 'S6',
    number: 27,
    type: 'B',
    floor: 7,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_B_select_floor7',
    nrId: 354,
  },
  {
    building: 'S6',
    number: 28,
    type: 'C',
    floor: 7,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_C_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 355,
  },
  {
    building: 'S6',
    number: 29,
    type: 'D',
    floor: 7,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_D_select_floor7',
    nrId: 356,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S6',
    number: 30,
    type: 'A',
    floor: 8,
    rooms: 4,
    area: 101.49,
    balconyArea: 13.06,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_A_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sa4rooms',
    nrId: 357,
  },
  {
    building: 'S6',
    number: 31,
    type: 'B',
    floor: 8,
    rooms: 3,
    area: 77.23,
    balconyArea: 10.03,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_B_select_floor8',
    nrId: 358,
  },
  {
    building: 'S6',
    number: 32,
    type: 'C',
    floor: 8,
    rooms: 6,
    area: 131.68,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_C_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/sc6rooms',
    nrId: 359,
  },
  {
    building: 'S6',
    number: 33,
    type: 'D',
    floor: 8,
    rooms: 5,
    area: 122,
    balconyArea: 18,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_D_select_floor8',
    nrId: 360,
    tourUrl: 'https://my.treedis.com/tour/sd5rooms',
  },
  {
    building: 'S6',
    number: 34,
    type: 'E',
    floor: 9,
    rooms: 6,
    area: 153.52,
    balconyArea: 78.2,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_E_select_floor9',
    nrId: 361,
  },
  {
    building: 'S6',
    number: 35,
    type: 'F',
    floor: 9,
    rooms: 6,
    area: 142.42,
    balconyArea: 89.71,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'S6_F_select_floor9',
    nrId: 362,
    tourUrl: 'https://my.treedis.com/tour/e688994f',
    kind: 'penthouse',
  },
];

export const hardCodedSlugVideoAsset: Asset = {
  id: 1,
  projectId: 1,
  title: '',
  type: AssetType.Gallery,
  filePath: 'https://static.treedis.com/assets/gallery/s1_f-video.mp4',
  url: 'https://static.treedis.com/assets/gallery/s1_f-video.mp4',
  order: 0,
  yad2Id: 0,
};
